import React from 'react'

interface KanbanColumnProps {
  children: React.ReactNode
}

export const KanbanColumn: React.FC<KanbanColumnProps> = ({ children }) => {
  return <div className="list-kanban">{children}</div>
}
